import { IAttendeeDetailsDTO } from './attendees.dao';
import { IEventRequestParams, IPaginationParams } from './shared.dto';

abstract class IAssetsDAO {
    public abstract getS3AssetUrlList(params: IEventRequestParams & { count: number; totalSize: number }): Promise<IAssetUrlDTO[]>;
    public abstract getS3AssetUrl(params: IEventRequestParams, url: string,): Promise<IAssetUrlDTO>;
    public abstract getAssets(params: IEventRequestParams): Promise<IAssetsListItemDTO>;
    public abstract updateAssets(params: IEventRequestParams, files: File[]): Promise<IAssetsListItemDTO>;
    public abstract uploadAssetToS3(url: string, assetFile: File): Promise<IAssetUrlDTO>;
    public abstract getAssetFile(url: string, fileName: string): Promise<void>;
    public abstract getAssetFileDownloadUrl(params: IEventRequestParams & { assetMetadataId: number }): Promise<IAssetFileDownloadUrlDTO>;
    public abstract getAssetsSpeakers(params: IEventRequestParams | IPaginationParams): Promise<IAssetsSpeakersListDTO>;
    public abstract deleteAssetFile(params: IEventRequestParams & { assetMetadataId?: number }): Promise<void>;
    public abstract deleteSpeakerAssetFile(params: IEventRequestParams & { attendeeId: number }): Promise<void>;
    public abstract addProfileImageWithS3(params: IEventRequestParams & { attendeeId: number }, file: File): Promise<IAttendeeDetailsDTO>;
    public abstract updateProfileImage(params: IEventRequestParams & { attendeeId: number },
        profileImage: ITitleObjectKeyDTO): Promise<IAttendeeDetailsDTO>;
    public abstract createAssetLink(params: IEventRequestParams & { assetMetadataId: number }): Promise<ITitleAssetUrlDTO>;
    public abstract deleteAssetLink(params: IEventRequestParams & { assetMetadataId: number }): Promise<void>;
}
interface IAssetsOrganizationListItemDTO {
    name: string;
    organizationId: number;
    speakers: IAssetsSpeakersDetailsDTO[];
}

interface IAssetsSpeakersDetailsDTO extends IAttendeeDetailsDTO {
    validationProfileImageError?: string;
    isLoadingProfileImage?: boolean;
    isAdded?: boolean;
    isBiographyAdded?: boolean;
}

interface IAssetsSpeakersListDTO {
    content: IAttendeeDetailsDTO[];
    totalElements: number;
}

interface IAssetsListItemDTO {
    files: ITitleAssetUrlDTO[];
}

interface IUpdateAssetsDTO {
    type: string;
    files: ITitleObjectKeyDTO[];
}

interface IAssetUrlDTO {
    assetUrl: string;
    objectKey: string;
}

interface ITitleAssetUrlDTO {
    title: string;
    assetUrl: string;
    objectKey: string;
    assetMetadataId?: number;
    publicDownloadLink?: string;
    uploadDateTime?: string;
}
interface ITitleObjectKeyDTO {
    title: string;
    objectKey: string;
    assetMetadataId?: number;
}

enum Category {
    UNCATEGORIZED = 'UNCATEGORIZED',
}

export enum UploadType {
    SINGLE = 'SINGLE',
    MULTIPLE = 'MULTIPLE'
}

interface IAssetFileDownloadUrlDTO {
    downloadUrl: string;
}

export {
    IAssetsDAO,
    IAssetsListItemDTO,
    IUpdateAssetsDTO,
    Category,
    IAssetUrlDTO,
    ITitleAssetUrlDTO,
    ITitleObjectKeyDTO,
    IAssetsSpeakersListDTO,
    IAssetsOrganizationListItemDTO,
    IAssetsSpeakersDetailsDTO,
    IAssetFileDownloadUrlDTO
};
